import {
  AddShoppingCartOutlined,
  AutoGraphOutlined,
  CardGiftcardOutlined,
  FactCheckOutlined,
  FireTruckOutlined,
  Inventory2Outlined,
  LibraryAddOutlined,
  MedicalInformationOutlined,
  PaymentOutlined,
  PeopleAltOutlined,
  PercentOutlined,
  PersonAddAlt1Outlined,
  PostAddOutlined,
} from '@mui/icons-material';

import { useSelector, useDispatch } from 'react-redux';
import { decodeToken, secondaryPermission } from '../../utils/settings';
import { useEffect, useState, useCallback } from 'react';
import IconReusable from '../../components/IconReusable';
import { resetBeneficiaryData } from '../../v2/Benefits/Beneficiary/reducer/beneficiaryReducer';

export const MODULE_TO_SECTION = {
  'business': 'MY BUSINESS',
  'humbee-benefits': 'HUMBEE BENEFITS',
  'analytics': 'ANALYTICS',
  'my-network': 'MY NETWORK',
  'onboard-buyer': 'ONBOARD BUYER',
};
export const useFullMenuStructure = () => {
  const [tokenData, setTokenData] = useState();
  
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };
  
  useEffect(() => {
    getTokenData();
  }, []);
  

  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
  }
  const fullMenuStructure = [
    {
      section: 'MY BUSINESS',
      items: [
        {
          key: 'create_order',
          path: '/create-po',
          icon: <AddShoppingCartOutlined />,
          title: 'Create PO',
          moduleKey: 'business',
        },
        {
          key: 'purchase_order',
          path: '/po-list',
          icon: <PostAddOutlined />,
          title: 'Purchase Order',
          moduleKey: 'business',
        },
        {
          key: 'dispatch_order',
          path: '/dispatch-status-list',
          icon: <FireTruckOutlined />,
          title: 'Dispatch Plan',
          moduleKey: 'business',
        },
        {
          key: 'secondary_order',
          path: '/order-booking/secondar-orders-list',
          icon: <LibraryAddOutlined />,
          title: 'Secondary Order',
          moduleKey: 'business',
        },
        {
          key: 'inventory',
          path: '/inventory',
          icon: <Inventory2Outlined />,
          title: 'Inventory',
          moduleKey: 'business',
        },
        {
          key: 'payment',
          path: '/payment',
          icon: <PaymentOutlined />,
          title: 'Payment',
          moduleKey: 'business',
        },
        {
          key: 'invoices',
          path: '/invoice-list',
          icon: <FactCheckOutlined />,
          title: 'Invoices',
          moduleKey: 'business',
        },
      ],
    },
    {
      section: 'MY NETWORK',
      items: [
        {
          title: 'Onboard Buyer',
          key: 'onboard_buyer',
          path: '/onboard-buyer',
          icon: <PersonAddAlt1Outlined />,
          moduleKey: 'onboard-buyer',
        },
        {
          title: 'My Network',
          key: 'my_network',
          path: '/my-network',
          icon: <IconReusable name="Network" size={24} />,
          moduleKey: 'onboard-buyer',
        },
      ],
    },
    {
      section: 'HUMBEE BENEFITS',
      items: [
        {
          title: 'My Benefits',
          key: 'my_benefits',
          path: '/benefits/mybenefits',
          icon: <MedicalInformationOutlined />,
          moduleKey: 'humbee-benefits',
        },
        {
          title: 'Beneficiary',
          key: 'beneficiary',
          path: '/beneficiary',
          icon: <PeopleAltOutlined />,
          moduleKey: 'humbee-benefits',
        },
        {
          title: 'Cumulative TDS',
          key: 'cumulative_tds',
          path: '/benefits/cumulative-tds',
          icon: <PercentOutlined />,
          moduleKey: 'humbee-benefits',
        },
        {
          title: 'My Rewards',
          key: 'my_rewards',
          path: '/benefits/rewards',
          icon: <CardGiftcardOutlined />,
          moduleKey: 'humbee-benefits',
        },
        {
          title: 'Network Rewards',
          key: 'network_rewards',
          path: '/benefits/network-rewards',
          icon: <CardGiftcardOutlined />,
          moduleKey: 'humbee-benefits',
        },
      ],
    },
    {
      section: 'ANALYTICS',
      items: [
        {
          title: 'Performance',
          key: 'performance',
          path: '/my-performance/Performance',
          icon: <AutoGraphOutlined />,
          moduleKey: 'analytics',
        },
        {
          title: 'Network Performance',
          key: 'network_performance',
          path: '/my-performance/network-performance',
          icon: <AutoGraphOutlined />,
          moduleKey: 'analytics',
        },
      ],
    },
  ];
  return {
    menuStructure: fullMenuStructure,
  };
};
